import styled from "@emotion/native";
import { Animated } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Text from "../../components/Text";
import * as drawer from "../../utils/drawer";

export const Container = styled.View(
    {
        flex: 1,
        position: "relative",
        // debug
        // borderWidth: 1,
        // borderColor: "yellow",
    },
    ({ theme }: any) => {
        return {
            backgroundColor: theme.color.background,
        };
    },
);

export const Background = styled(Animated.Image)(
    {
        position: "absolute",
        resizeMode: "cover",
    },
    ({ width, height, translateX }: any) => {
        return {
            width,
            height,
            transform: [
                {
                    translateX,
                },
            ],
        };
    },
);

export const Header = styled.View(
    {
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        zIndex: 9,
        minHeight: drawer.BUTTON_HEIGHT + drawer.BUTTON_TOP,
        position: "absolute",
        top: 0,
        left: 0,

        // debug
        // borderColor: "blue",
        // borderWidth: 1,
    },
    ({ theme }: any) => {
        const insets = useSafeAreaInsets();
        return {
            paddingTop: insets.top,
            paddingBottom: 20,
            backgroundColor: theme.color.transparentBackground,
        };
    },
);

export const Title = styled(Text)(
    {
        textAlign: "center",
        paddingHorizontal: 10,
        paddingVertical: 0,
    },
    () => {
        return {
            paddingHorizontal: drawer.BUTTON_WIDTH + drawer.BUTTON_LEFT,
        };
    },
);
